import {ToRGBA, MixColors} from '@/utils/colors';

export default {
  purple: { // Dark blue (default)
    '--sys': '#7A4BA2',
    '--sys-hover': ToRGBA('#7A4BA2', 0.7),
    '--sys-active': ToRGBA('#7A4BA2', 0.5),
    '--sys-icon': MixColors('#979797', '#7A4BA2', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#7A4BA2', 0.15)
  },
  orange: { // Orange
    '--sys': '#FF7E36',
    '--sys-hover': ToRGBA('#FF7E36', 0.7),
    '--sys-active': ToRGBA('#FF7E36', 0.5),
    '--sys-icon': MixColors('#979797', '#FF7E36', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#FF7E36', 0.15)
  },
  red: { // Red
    '--sys': '#F4624E',
    '--sys-hover': ToRGBA('#F4624E', 0.7),
    '--sys-active': ToRGBA('#F4624E', 0.5),
    '--sys-icon': MixColors('#979797', '#F4624E', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#F4624E', 0.15)
  },
  blue: { // Blue
    '--sys': '#7E56F2',
    '--sys-hover': ToRGBA('#7E56F2', 0.7),
    '--sys-active': ToRGBA('#7E56F2', 0.5),
    '--sys-icon': MixColors('#979797', '#7E56F2', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#7E56F2', 0.15)
  },
  green: { // Green
    '--sys': '#48D08F',
    '--sys-hover': ToRGBA('#48D08F', 0.7),
    '--sys-active': ToRGBA('#48D08F', 0.5),
    '--sys-icon': MixColors('#979797', '#48D08F', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#48D08F', 0.15)
  },
  grey: { // Black
    '--sys': '#424347',
    '--sys-hover': ToRGBA('#424347', 0.7),
    '--sys-active': ToRGBA('#424347', 0.5),
    '--sys-icon': MixColors('#979797', '#424347', 0.2),
    '--sys-bg': MixColors('#FFFFFF', '#424347', 0.15)
  }

  // TEMP old color scheme
  // purple: { // Dark blue (default)
  //   '--sys': '#A23896',
  //   '--sys-hover': '#7B2371',
  //   '--sys-active': '#5B1954',
  //   '--sys-icon': '#8E8BAA',
  //   '--sys-bg': '#F6F4FB'
  // },
  // orange: { // Orange
  //   '--sys': '#FFAA2C',
  //   '--sys-hover': '#F19A18',
  //   '--sys-active': '#E08E14',
  //   '--sys-icon': '#9C8F81',
  //   '--sys-bg': '#FBF3E8'
  // },
  // red: { // Red
  //   '--sys': '#F55725',
  //   '--sys-hover': '#E93E08',
  //   '--sys-active': '#E22B12',
  //   '--sys-icon': '#B38882',
  //   '--sys-bg': '#FFF7F4'
  // },
  // blue: { // Blue
  //   '--sys': '#4080FC',
  //   '--sys-hover': '#2869E9',
  //   '--sys-active': '#1C57CB',
  //   '--sys-icon': '#517298',
  //   '--sys-bg': '#F5F8FF'
  // },
  // green: { // Green
  //   '--sys': '#8DD052',
  //   '--sys-hover': '#83C14D',
  //   '--sys-active': '#72B139',
  //   '--sys-icon': '#7F916F',
  //   '--sys-bg': '#EEF4DF'
  // },
  // grey: { // Black
  //   '--sys': '#545356',
  //   '--sys-hover': '#303134',
  //   '--sys-active': '#1F2022',
  //   '--sys-icon': '#6F7075',
  //   '--sys-bg': '#EEEEEE'
  // }
}